import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'dateToUTC' })
export class DateToUTCPipe implements PipeTransform {
  transform(date: Date): number {
    if (!date)
      return null;

    return Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds())
  }
}
